import React, { useState } from 'react'
import { useNavigate } from "react-router-dom"

const Signup = (props) => {
    const [credentials, setCredentials] = useState({ name: "", email: "", password: "", cpassword: "" })
    let navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (credentials.password === credentials.cpassword) {
            const { name, email, password } = credentials;
            const response = await fetch("https://inotebook.adaptable.app/api/auth/createuser", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ name, email, password })
            });
            const json = await response.json();
//             console.log(json);
            if (json.success) {
                // Save the auth token and redirect
                localStorage.setItem('token', json.authtoken);
                navigate("/");
                props.showAlert("Account Created Successfully!", "success")
            }
            else {
                props.showAlert("Invalid Details!", "warning")
            }
        }
        else {
            props.showAlert("Confirm Password does not match!", "danger")
        }
    }

    const onChange = (e) => {
        setCredentials({ ...credentials, [e.target.name]: e.target.value })
    }

    return (
        <div className="container mt-2">
            <h1 className="text-center text-success mb-4">Create an account to use iNotebook</h1>
            <form onSubmit={handleSubmit} style={{ color: props.changeColor === "dark" ? "white" : "black" }}>
                <div className="mb-3">
                    <label htmlFor="name" className="form-label">Name</label>
                    <input type="text" className="form-control" id="name" name="name" onChange={onChange} aria-describedby="emailHelp" style={{
                        color: props.changeColor === "dark" ? "white" : "black",
                        backgroundColor:
                            props.changeColor === "dark" ? "#212529" : "white",
                    }} />
                </div>
                <div className="mb-3">
                    <label htmlFor="email" className="form-label">Email address</label>
                    <input type="email" className="form-control" id="email" name="email" onChange={onChange} aria-describedby="emailHelp" style={{
                        color: props.changeColor === "dark" ? "white" : "black",
                        backgroundColor:
                            props.changeColor === "dark" ? "#212529" : "white",
                    }} />
                    <div id="emailHelp" className="form-text">We'll never share your email with anyone else.</div>
                </div>
                <div className="mb-3">
                    <label htmlFor="password" className="form-label">Password</label>
                    <input type="password" className="form-control" id="password" name="password" onChange={onChange} minLength={5} required style={{
                        color: props.changeColor === "dark" ? "white" : "black",
                        backgroundColor:
                            props.changeColor === "dark" ? "#212529" : "white",
                    }} />
                </div>
                <div className="mb-3">
                    <label htmlFor="cpassword" className="form-label">Confirm Password</label>
                    <input type="password" className="form-control" id="cpassword" name="cpassword" onChange={onChange} minLength={5} required style={{
                        color: props.changeColor === "dark" ? "white" : "black",
                        backgroundColor:
                            props.changeColor === "dark" ? "#212529" : "white",
                    }} />
                </div>
                <button type="submit" className="btn btn-success">Submit</button>
            </form>
        </div>
    )
}

export default Signup
